<div class="es-hts-line-panel">
  <div class="es-hts-line-panel__header">
    <div class="es-hts-line-panel__nav" *ngIf="isNavigable">
      <button
        type="button"
        class="es-hts-line-panel__nav-button es-hts-line-panel__nav-button--left"
        [disabled]="isFirst"
        [attr.aria-label]="'BUTTON.BACK' | translate"
        (click)="prev.emit()"
      >
        <img src="assets/icons/icon_arrow_left_sm_gray.svg" alt="" />
      </button>
      <button
        type="button"
        class="es-hts-line-panel__nav-button es-hts-line-panel__nav-button--right"
        [disabled]="isLast"
        [attr.aria-label]="'LABELS.NEXT' | translate"
        (click)="next.emit()"
      >
        <img src="assets/icons/icon_arrow_left_sm_gray.svg" alt="" />
      </button>
    </div>
    <button type="button" class="es-hts-line-panel__close" [attr.aria-label]="'BUTTON.CLOSE' | translate" (click)="close.emit()">×</button>
  </div>

  <div class="es-hts-line-panel__catalog" *ngIf="isCatalogOpen">
    <app-bina-catalog-search-sidebar
      [company]="company"
      [initialSearch]="catalogInitialSearch"
      (htsInsert)="onCatalogInsert($event)"
      (suggestionInsert)="onSuggestionInsert($event)"
      (close)="closeCatalog()"
    ></app-bina-catalog-search-sidebar>
  </div>

  <div class="es-hts-line-panel__body" [class.es-hts-line-panel__body--hidden]="isCatalogOpen">
    <ng-container *ngFor="let ref of lineRefs; trackBy: trackByLineId">
      <div class="es-hts-line-panel__table" *ngIf="tableInvoice">
        <es-details-invoice-ocr-card-hts-desktop
          [invoice]="tableInvoice"
          [shipmentExportDate]="shipmentExportDate"
          [currencyRate]="1"
          [isEditable]="false"
          [indexOffset]="indexOffset"
        ></es-details-invoice-ocr-card-hts-desktop>
      </div>

      <div class="es-hts-line-panel__form" *ngIf="invoice">
        <es-line-item-default-desktop
          [itemId]="ref.lineId"
          [shipmentId]="ref.shipmentId"
          [invoice]="invoice"
          [isHideFooter]="true"
          [isShowHint]="false"
          [isHideFindHts]="true"
          [isReadMode]="!isEditMode"
          (lineDataSaved)="onLineDataSaved($event)"
          (lineInserted)="onLineInserted()"
          (lineInsertFailed)="onLineInsertFailed()"
          (findInCatalogRequested)="openCatalog()"
        ></es-line-item-default-desktop>
      </div>
    </ng-container>
  </div>

  <div class="es-hts-line-panel__footer" *ngIf="isShowFooter">
    <button type="button" class="btn btn-square btn-primary" *ngIf="isShowEditButton" (click)="enterEditMode()">
      {{ "BUTTON.EDIT" | translate }}
    </button>
    <button type="button" class="btn btn-square btn-outline-bordered" *ngIf="isShowCancelButton" (click)="onCancel()">
      {{ "BUTTON.CANCEL" | translate }}
    </button>
    <button type="button" class="btn btn-square btn-primary" *ngIf="isEditMode" [disabled]="isSaveDisabled" (click)="onSave()">
      {{ "BUTTON.SAVE" | translate }}
    </button>
  </div>
</div>
